/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { request } from './client';
import { validateVersionConfig } from './util';
const introspect = function introspect({ withCredentials, domain, interactionHandle, stateHandle, version, }) {
    return __awaiter(this, void 0, void 0, function* () {
        validateVersionConfig(version);
        const target = `${domain}/idp/idx/introspect`;
        const body = stateHandle ? { stateToken: stateHandle } : { interactionHandle };
        const headers = {
            'content-type': `application/ion+json; okta-version=${version}`,
            accept: `application/ion+json; okta-version=${version}`,
        };
        const credentials = withCredentials === false ? 'omit' : 'include';
        const response = yield request(target, { credentials, headers, body: JSON.stringify(body) });
        const requestDidSucceed = response.ok;
        const rawIdxResponse = yield response.json();
        // Throw IDX response if request did not succeed. This behavior will be removed in version 7.0: OKTA-481844
        if (!requestDidSucceed) {
            throw rawIdxResponse;
        }
        return rawIdxResponse;
    });
};
export default introspect;
